import type { Step, CallBackProps } from 'react-joyride';

export interface OnboardingState {
  run: boolean;
  stepIndex: number;
  steps: Step[];
  tourType: TourType | null;
  completedTours: TourType[];
  skippedTours: TourType[];
  isOnboardingEnabled: boolean;
  userPreferences: UserPreferences;
  lastCompletedAt: string | null;
}

export interface UserPreferences {
  showOnLogin: boolean;
  autoStartTours: boolean;
  disableAnimation: boolean;
}

export enum TourType {
  FIRST_LOGIN = 'first_login',
  OVERVIEW = 'overview',
  CONVERSATIONS = 'conversations',
  SIDEBAR = 'sidebar',
  AGENTS = 'agents',
  SETTINGS = 'settings',
  REPORTS = 'reports',
  RECORDS = 'records',
  DOCUMENTS = 'documents',
  CALENDAR = 'calendar',
  SCHEDULER = 'scheduler',
  LOGS = 'logs',
  TEAMS = 'teams'
}

export enum TourTrigger {
  FIRST_LOGIN = 'first_login',
  FEATURE_FIRST_VISIT = 'first_visit',
  MANUAL = 'manual',
  UPDATE = 'feature_update',
  ROLE_CHANGE = 'role_change'
}

export interface OnboardingActions {
  startTour: (tourType: TourType) => void;
  stopTour: () => void;
  resetTour: () => void;
  skipTour: (tourType: TourType) => Promise<void>;
  completeTour: (tourType: TourType) => Promise<void>;
  setStepIndex: (index: number) => void;
  toggleOnboarding: (enabled: boolean) => void;
  updatePreferences: (preferences: Partial<UserPreferences>) => void;
  resetAllTours: () => Promise<void>;
  isTourCompleted: (tourType: TourType) => boolean;
  isTourSkipped: (tourType: TourType) => boolean;
  syncTourProgressFromBackend: () => Promise<void>;
}

export interface OnboardingContextValue extends OnboardingState, OnboardingActions {}

export type JoyrideCallbackData = CallBackProps;

export type { Step };
